import { Logo } from "@/components/molecules/Logo/Logo";
import Text from "@/components/atoms/Text/Text";

import logoBrand from '@/assets/video/logoLoading.svg'

const BrandHeader = () => (
    <div className="flex items-center gap-2 sm:gap-3">
      <Logo src={logoBrand} alt="logo" width={100} height={100} />
      <div className="hidden sm:block">
        <Text variant="title" className="text-xl sm:text-2xl">ARETI</Text>
        <Text variant="caption">Holdings Inc</Text>
      </div>
    </div>
  );

export default BrandHeader;